export default "__VITE_ASSET__D0syT$F$__"